import React, { useState, useEffect, useContext } from "react";
import { CloudArrowDown24Filled, CloudArrowDown24Regular, CloudCheckmark24Regular, CloudDismiss24Regular } from "@fluentui/react-icons";
import "./Styles/ImageUploadStatus.css";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import ModalMain from "../../../components/Modal/ModalMain";
import ModalHeader from "../../../components/Modal/ModalHeader";
import ModalFooter from "../../../components/Modal/ModalFooter";
import { t } from "i18next";
import Moment from "moment";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { getSeriesInformation } from "../../../service/StudyListService";
import themeContext from "../../../context/theme/ThemeContext";
import SeriesUploadHistory from "./SeriesUploadHistory";

const ImageUploadStatus = ({ status, studyId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openPopup = () => {
    setIsModalOpen(true);
  };

  const renderIcon = () => {
     const commonProps = {
      style: {
        fontSize: "24px",
      },
    };

    switch (status) {
      case "IN_PROGRESS":
        return (
          <div className="cloud-icon-wrapper">
            <CloudArrowDown24Filled {...commonProps} className="cloud-icon-base" onClick={openPopup} />
            <CloudArrowDown24Filled {...commonProps} className="cloud-icon-fill" onClick={openPopup} />
          </div>
        );
      case "COMPLETE":
        return <CloudCheckmark24Regular {...commonProps} className="cloud-icon-green" onClick={openPopup}/>;
      case "NO_IMAGES":
      default:
        return <CloudDismiss24Regular {...commonProps} className="cloud-icon-grey" onClick={openPopup} />;
    }
  };

  let PrimaryButtonList = [];
  
  let DefaultButtonList = [
    {
        title: t("button.cancel"),
        onclick: () => setIsModalOpen(false),
    },
  ];
  
  let modalDetails = {
      header: (
        <ModalHeader
          updatedModal={true}
          patientName="Mary Frank"
          patientID="123456"
          heading={"Series Upload Timeline"}
          handleCancel={() => setIsModalOpen(false)}
        />
      ),
      footer:
        <ModalFooter 
          PrimaryButtonList={PrimaryButtonList}
          DefaultButtonList={DefaultButtonList}
        />,
      body: (
        <SeriesUploadHistory studyId={studyId} />
      ),
      width: "500px",
    };

  const getTootTip = () => {
    switch (status) {
      case "IN_PROGRESS":
        return "In Progress";
      case "COMPLETE":
        return "Complete";
      case "NO_IMAGES":
        return "-";
      default:
        return "-";
    }
  };

  return (<>
    <CustomToolTipHost content={`Image Upload Status: ${getTootTip()}`} >
        <div className="study-list-report-icon">
      {renderIcon()}
      </div>
    </CustomToolTipHost>

    {isModalOpen && 
      <ModalMain
        showModal={isModalOpen}
        modalDetails={modalDetails}
      />}
    </>
  );
};

export default ImageUploadStatus;